import {ApprovalRequest, ApprovalResponse} from "@/types/auth";

export async function authenticateWithPhone(phoneNumber: string, mno: string) {
    const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({phoneNumber, mno}),
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to start 2FA.");
    }

    return response.json();
}

export async function checkApproval({msisdn, requestId} : ApprovalRequest): Promise<ApprovalResponse> {
    const response = await fetch(`/api/auth/checkApproval/${msisdn}?requestId=${requestId}`, {
        method: "GET",
        headers: {"Content-Type": "application/json"},
    });
    if (!response.ok) {
        throw new Error("Polling failed.");
    }

    return response.json();
}
